module.exports = __webpack_public_path__ + "media/retour-definitif.42c4dc8f.mp3";